import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import Scrollbars from 'react-custom-scrollbars'
import { Trans, WithTranslation } from 'react-i18next'
import { FiFilter, FiX } from 'react-icons/fi'
import { FormErrors } from 'redux-form'
import Flex from 'typescript-styled-flex'
import Badge from '../../../../components/Template/Badge'
import Button from '../../../../components/Template/Button'
import FilterRooms from '../../../Form/FilterRooms'
import { IFilterRoomsValues } from '../../../Form/FilterRooms/withReduxForm'
import { IWithSize } from '../../Calendar/Calendar'
import ClickAwayBackground from './components/ClickAwayBackground'
import FilteringFormBackground from './components/FilteringFormBackground'
import Footer from './components/Footer'
import Header from './components/Header'
import Title from './components/Title'
import Wrapper from './components/Wrapper'
import { Mixpanel } from '../../../../utils/Mixpanel'

type IDrawer = IDrawerProps &
  IDrawerDispatch &
  IDrawerActions &
  IDrawerFormProps

function Drawer({
  activeFilters = 0,
  toggleDrawer,
  submitChanges,
  clearChanges,
  t,
  formErrors,
  size = 1,
}: IDrawer & WithTranslation & IWithSize) {
  const [toggleTimeout, setToggleTimeout] = useState()

  function filter() {
    Mixpanel.track('Calendar Filter Completed', {})
    submitChanges()

    setToggleTimeout(setTimeout(() => {
      toggleDrawer()
      setToggleTimeout(null)
    }, 200) as any)
  }

  useEffect(() => {
    if (!isEmpty(formErrors) && toggleTimeout) {
      clearTimeout(toggleTimeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formErrors])

  function clearAllString(): string {
    const str = t('clear_all').toLowerCase()
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  return (
    <Wrapper>
      <FilteringFormBackground>
        <Header size={size}>
          <Flex alignCenter={true} row={true} style={{ width: '50%' }}>
            <FiFilter
              size={`${16 * size}px`}
              style={{ margin: `0 ${0.25 * size}em` }}
            />
            <Badge size={size} primary={activeFilters > 0}>
              {activeFilters}
            </Badge>
            <Title size={size}>
              <Trans i18nKey={'filter_dialog_title'} />
            </Title>
          </Flex>
          <Flex alignCenter={true} justifyEnd={true} style={{ width: '50%' }}>
            <FiX
              size={`${16 * size}px`}
              style={{ cursor: 'pointer' }}
              onClick={toggleDrawer}
            />
          </Flex>
        </Header>
        <Scrollbars
          style={{ height: `calc(100% - ${48 * size}px - ${61 * size}px)` }}
          hideTracksWhenNotNeeded={true}
          autoHide={true}
        >
          <FilterRooms size={size} />
        </Scrollbars>
        <Footer size={size}>
          <Button
            size={size}
            style={{ marginRight: `${5 * size}px`, width: '50%' }}
            onClick={clearChanges}
          >
            {clearAllString()}
          </Button>
          <Button
            size={size}
            style={{ marginLeft: `${5 * size}px`, width: '50%' }}
            primary={true}
            onClick={filter}
          >
            <Trans i18nKey={'filter_dialog_button'}>Filtruj</Trans>
          </Button>
        </Footer>
      </FilteringFormBackground>
      <ClickAwayBackground onClick={toggleDrawer} />
    </Wrapper>
  )
}

export default Drawer

export interface IDrawerProps {
  activeFilters?: number
}

export interface IDrawerFormProps {
  formErrors: FormErrors<IFilterRoomsValues, 'string'>
}

export interface IDrawerDispatch {
  submitChanges?: () => void
  clearChanges?: () => void
}

export interface IDrawerActions {
  toggleDrawer?: () => void
}
